import { t } from '@lingui/macro';

export enum NoDataInformationType {
  EmptySelectedSites,
  EmptySitesFilter,
  ChangePeriodFilter,
  ChangePeriodFilterOrRefresh,
  ChangePeriodAndDataFilters,
  ChangePeriodChannelConditionAcknowledgeFilters,
  EmptySelectedSitesList,
  SelectDifferentAccount,
  EmptyChannelList,
  EmptyTransientsGraph,
  EmptySiteCommands,
  EmptyStandardConditionAlarms,
  NoChannelDataOnGraph,
}

export const noDataInformationOptionsFn = (): Record<NoDataInformationType, string> => ({
  [NoDataInformationType.EmptySelectedSites]: t`Select sites in Site List 'All' tab`,
  [NoDataInformationType.EmptySitesFilter]: t`Select one of the sites in Sites filter to see the data`,
  [NoDataInformationType.ChangePeriodFilter]: t`Try to change period filter to see the data`,
  [NoDataInformationType.ChangePeriodFilterOrRefresh]: t`Try to change period filter or use refresh button to see the data`,
  [NoDataInformationType.ChangePeriodAndDataFilters]: t`Try to change period or data filter to see the data`,
  [NoDataInformationType.ChangePeriodChannelConditionAcknowledgeFilters]: t`Try to change period, channel, condition or acknowledge filter to see the data`,
  [NoDataInformationType.EmptySelectedSitesList]: t`Add new selected sites list to see loaded ones`,
  [NoDataInformationType.SelectDifferentAccount]: t`Try to select different account in 'Accounts' tab`,
  [NoDataInformationType.EmptyChannelList]: t`There is en empty channels list for a particular site`,
  [NoDataInformationType.EmptyTransientsGraph]: t`There is no data for transient graph`,
  [NoDataInformationType.EmptySiteCommands]: t`There are no commands for this site`,
  [NoDataInformationType.EmptyStandardConditionAlarms]: t`There are no condition alarms for this site`,
  [NoDataInformationType.NoChannelDataOnGraph]: t`There is no channel data for selected sites. Data was requested to be sent to DataView`,
});
